<script>
	import Head from  "$lib/sections/Head.svelte";
	import PageBanner from  "$lib/sections/PageBanner.svelte";
	import Features from  "$lib/sections/Features.svelte";
	import SideBySide from  "$lib/sections/SideBySide.svelte";
	import Testimonials from  "$lib/sections/Testimonials.svelte";

	export let data;

	let lang;
	$: lang = data.lang;

	let area;
	$: area = data.area;

	const col = "home";
</script>

<Head {data} {lang} {area} {col} settingId={"Head"} />

<PageBanner {data} {lang} {area} {col} settingId={"PageBanner"} />

<Features {data} {lang} {area} {col} settingId={"Features 01"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 01"} />

<Features {data} {lang} {area} {col} settingId={"Features Memberships"} />

<Features {data} {lang} {area} {col} settingId={"Features 02"} />

<Features {data} {lang} {area} {col} settingId={"Features 03"} />

<Features {data} {lang} {area} {col} settingId={"Features Services Grid"} />

<Features {data} {lang} {area} {col} settingId={"Features 05"} />

<Testimonials {data} {lang} {area} {col} settingId={"Testimonials"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 02"} />

<SideBySide {data} {lang} {area} {col} settingId={"SideBySide 03"} />

<Features {data} {lang} {area} {col} settingId={"Features Article Grid"} />
